import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import type { AssessmentChecklistItem } from "../../services/assessmentService";
import SelectImpactAssessmentPlanDialogBase from "../../components/AssessmentCenterPage/SelectImpactAssessmentPlanDialog";
import { useBrandThemeColors } from "../../branding";

export type SelectImpactAssessmentPlanDialogProps = Readonly<{
  open: boolean;
  onClose: () => void;
  runLoading: boolean;
  onRun: (plan: AssessmentChecklistItem) => void;
  runRegulationIds?: string[];
}>;

export default function SelectImpactAssessmentPlanDialog({
  open,
  onClose,
  runLoading,
  onRun,
  runRegulationIds,
}: SelectImpactAssessmentPlanDialogProps) {
  const { primaryColor, primaryFontColor } = useBrandThemeColors();

  return (
    <SelectImpactAssessmentPlanDialogBase
      open={open}
      onClose={onClose}
      runRegulationIds={runRegulationIds}
      footer={({ selectedPlan, loading, canReadChecklist }) => {
        const canRun =
          Boolean(selectedPlan) &&
          canReadChecklist &&
          !loading &&
          !runLoading;

        return (
          <>
            <Button
              variant="outlined"
              onClick={onClose}
              sx={{
                textTransform: "none",
                borderColor: primaryColor,
                color: primaryColor,
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              disabled={!canRun}
              onClick={() => selectedPlan && onRun(selectedPlan)}
              sx={{
                textTransform: "none",
                backgroundColor: primaryColor,
                color: primaryFontColor,
                "&:hover": { backgroundColor: primaryColor },
              }}
            >
              {runLoading ? (
                <>
                  <CircularProgress size={16} sx={{ mr: 1, color: "#fff" }} />
                  Running...
                </>
              ) : (
                "Run AI Assessment"
              )}
            </Button>
          </>
        );
      }}
    />
  );
}

